import { motion } from "framer-motion";
import { Check, ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/i18n";
import { scrollToId } from "@/utils";

export const InsuranceBand = () => {
  const { t } = useLanguage();
  return (
    <section id="insurance" className="relative bg-[#D4AF37] text-black py-24 sm:py-32 overflow-hidden" data-testid="insurance-band">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
        >
          <span className="text-xs font-bold tracking-[0.25em] uppercase text-black/60">{t.insurance.label}</span>
          <h2 className="font-display font-bold tracking-tighter leading-[0.95] text-5xl sm:text-7xl lg:text-8xl mt-6">
            {t.insurance.title}
            <br />
            <span className="text-black/50">{t.insurance.title2}</span>
          </h2>
          <p className="mt-8 max-w-2xl text-base sm:text-lg text-black/70 leading-relaxed font-medium">
            {t.insurance.sub}
          </p>
          <div className="mt-10 flex flex-wrap gap-x-10 gap-y-4">
            {t.insurance.points.map((p) => (
              <div key={p} className="flex items-center gap-2.5 font-semibold text-sm sm:text-base">
                <span className="w-6 h-6 rounded-full bg-black text-[#D4AF37] flex items-center justify-center">
                  <Check className="w-3.5 h-3.5" />
                </span>
                {p}
              </div>
            ))}
          </div>
          <button
            onClick={() => scrollToId("#quote")}
            data-testid="insurance-claim-cta"
            className="mt-12 inline-flex items-center gap-2 bg-black text-[#D4AF37] font-bold px-8 py-4 rounded-full transition-transform duration-300 hover:scale-105"
          >
            {t.insurance.cta}
            <ArrowUpRight className="w-5 h-5" />
          </button>
        </motion.div>
      </div>
    </section>
  );
};
